
    import './styles.scoped.css';
    export default {
  "radio-button": "awsui_radio-button_feeqa_1rmzd_5"
};
  